import { z } from "zod";

export const IntegrationSchema = z.object({
  name: z.string(),
  slug: z.string(),
  enabled: z.boolean(),
});

export type Integration = z.infer<typeof IntegrationSchema>;
